import { Favorite, NewsCard } from '@components';
import {
    Button,
    Card,
    Container,
    CustomIcon,
    Typography,
    mesChantiers,
    richessesHumaines,
    santeSecurite,
    remonteeEvenement
} from '@design-system';
import React from 'react';
import { FaBookmark } from 'react-icons/fa';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import './HomePage.scss';
import { NewsSkeleton } from './NewsSkeleton';
import { useHomePageVM } from './useHomePageVM';
import { FavoritesSkeleton } from './FavoritesSkeleton';

export const HomePage: React.FC = () => {
    const navigate = useNavigate();

    const { isLoadingNews, isLoadingFavorites, latestNews, favorites } = useHomePageVM();

    return (
        <Container className="home-page" height="fill">
            <Container padding="none">
                <div className="news-header">
                    <Typography intrinsic="h2" defaultSpacing>
                        Actualités
                    </Typography>

                    <Button
                        color="grey"
                        variant="tertiary"
                        size="small"
                        secondaryIcon={<MdKeyboardArrowRight className="ml--x-small-spacing" />}
                        className="no-padding"
                        onClick={() => navigate('/news')}
                    >
                        <Typography intrinsic="h4">Voir toutes</Typography>
                    </Button>
                </div>

                <div className="news-container">
                    {isLoadingNews && <NewsSkeleton />}

                    {!isLoadingNews && latestNews && <NewsCard news={latestNews} callback={() => navigate(`/news?id=${latestNews.id}`)} />}
                </div>
            </Container>

            <Container padding="none" className="quickaccess-container">
                <Typography intrinsic="h2" defaultSpacing>
                    Accès rapides
                </Typography>

                <Button
                    icon={<CustomIcon src={mesChantiers} alt="Mes chantiers" />}
                    quickaccess
                    color="red"
                    onClick={() => navigate('/mes-chantiers')}
                >
                    <Typography intrinsic="h3">Mes chantiers</Typography>
                </Button>

                <Button
                    icon={<CustomIcon src={richessesHumaines} alt="Richesses humaines" />}
                    quickaccess
                    color="yellow"
                    onClick={() => navigate('/richesses-humaines')}
                >
                    <Typography intrinsic="h3">Richesses humaines</Typography>
                </Button>

                <Button
                    icon={<CustomIcon src={santeSecurite} alt="Santé sécurité au travail" />}
                    quickaccess
                    color="blue"
                    onClick={() => navigate('/sante-securite')}
                >
                    <Typography intrinsic="h3">Santé sécurité au travail</Typography>
                </Button>

                <Button
                    icon={<CustomIcon src={remonteeEvenement} alt="Remontée d'évènement" />}
                    quickaccess
                    color="green"
                    onClick={() => navigate('/event-feedback')}
                >
                    <Typography intrinsic="h3">Remontée d'évènement</Typography>
                </Button>
            </Container>

            <Container padding="none" className="favorites mb-medium-spacing">
                <Typography intrinsic="h2" icon={<FaBookmark />} iconPosition="left" defaultSpacing>
                    Favoris
                </Typography>

                <div className="favorites-container">
                    <Card filled row>
                        {isLoadingFavorites && <FavoritesSkeleton />}

                        {!isLoadingFavorites && favorites.length > 0 ? (
                            favorites.map(({ id, reference }) => <Favorite key={id} reference={reference} />)
                        ) : (
                            <div className="favorites-empty">
                                <Typography intrinsic="h3" color="grey">
                                    Aucun favori
                                </Typography>
                                <Typography intrinsic="p">
                                    Ajoutez des pages en favoris pour accéder facilement aux modules de votre choix.
                                </Typography>
                            </div>
                        )}
                    </Card>
                </div>
            </Container>
        </Container>
    );
};
